import { render, staticRenderFns } from "./SubCardSideControl.vue?vue&type=template&id=2befdb3e&scoped=true"
import script from "./SubCardSideControl.vue?vue&type=script&lang=js"
export * from "./SubCardSideControl.vue?vue&type=script&lang=js"
import style0 from "./SubCardSideControl.vue?vue&type=style&index=0&id=2befdb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2befdb3e",
  null
  
)

export default component.exports